import { BOX_SHADOW } from 'styles/Colors';

const BASE_BORDER_RADIUS = '3px';
const BASE_BOX_SHADOW = `0 0.25rem 0.5rem ${BOX_SHADOW}`;

export { BASE_BORDER_RADIUS, BASE_BOX_SHADOW };
